import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
//import "./Qualifications.scss";

import Helmet from "react-helmet";
import {config} from "../../../../config";
import CategoriesModeTinder from "../Components/CategoriesModeTinder/CategoriesModeTinder";
import CategoriesModeVideo from "../Components/CategoriesModeVideo/CategoriesModeVideo";
//import CategoriesModeList from "./Components/CategoriesModeList/CategoriesModeList";



class TagModerationVerification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayCategory : "temperature"
        }
    }


    render() {
        return (
            <div id="tag-moderations-verification">
                <Helmet>
                    <title>{config.preTitle} Tag Moderations {config.postTitle}</title>
                </Helmet>

                <div className={"container"}>
                    <div className="card">
                        <h2>Vérification du contenu</h2>
                        <CategoriesModeVideo
                            currentUrl={this.props.match.url}
                            displayCategory={this.state.displayCategory}
                            handleDisplayCategory={(catId)=>this.setState({displayCategory : catId})}
                            type={"verification"}
                        />
                        <CategoriesModeTinder
                            currentUrl={this.props.match.url}
                            displayCategory={this.state.displayCategory}
                            handleDisplayCategory={(catId)=>this.setState({displayCategory : catId})}
                            type={"verification"}
                        />
                        {/*<CategoriesModeList
                            displayCategory={this.state.displayCategory}
                            handleDisplayCategory={(catId)=>this.setState({displayCategory : catId})}
                        />*/}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserInitialized : state.currentUser.initialized,
        currentUserLoading : state.currentUser.loading
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({

}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TagModerationVerification);